import { walletConnection } from '../actions/type';
// import {StorageService} from "../services";
import * as StorageService from '../services/storage.service';

function getInitialState() {
  const wallet = StorageService.getObject('wallet');

  const initialState =
    wallet != null && wallet.walletAddress != null
      ? {
          walletConnected: true,
          wallet,
        }
      : {
          walletConnected: false,
          wallet,
        };
  return initialState;
}

function connectWallet(state = null, action) {
  if (state == null) {
    state = getInitialState();
  }

  const { type, payload } = action;
  switch (type) {
    case walletConnection.SUCCESS:
      return {
        ...state,
        walletConnected: true,
        wallet: payload,
      };
    case walletConnection.DISCONNECT:
      return {
        ...state,
        walletConnected: false,
        wallet: payload,
      };
    default:
      return state;
  }
}

export default connectWallet;
